import React from 'react';
import { Row, Col } from 'react-bootstrap';
import Icon from '../../../../common/components/Icon/Icon';
import Button from '../../../../common/components/Button/Button';
import ProductTemplateBox from '../ProductTemplateBox/ProductTemplateBox';
import ActivateMultipleSchemesModal from '../ActivateMultipleSchemesModal/ActivateMultipleSchemesModal';
import { InternalButtonBar } from '../../../layout/components';
import SchemeContainer from '../SchemeContainer/SchemeContainer';
import { PRODUCT_BUTTONS } from '../../helpers/productButtons';
import './SchemesSummary.scss';
import SchemesExportModal from '../SchemesExportModal/SchemesExportModal';
import { ICON_MAP } from '../../../../common/components/SvgIcons/productIcons';

const SCHEME_TYPE_ORDER = ['single', 'annual', 'standard', 'enhanced'];

export const SchemesByCoverLevel = ({ schemes, baseUrl, onRefreshPage }) => {
  const schemeTypes = Object.keys(schemes);

  const orderedSchemeTypes = schemeTypes.sort((stA, stB) => {
    return SCHEME_TYPE_ORDER.indexOf(stA) < SCHEME_TYPE_ORDER.indexOf(stB) ? -1 : 1;
  });
  const numberOfSchemeType = orderedSchemeTypes?.length;

  if (!numberOfSchemeType) {
    return null;
  }

  const colSize = 12 / numberOfSchemeType;

  return (
    <Col sm={12}>
      <Row className="schemes-summary">
        {orderedSchemeTypes.map((schemeType) => {
          return (
            <Col sm={colSize}>
              <h2 className={'capitalise'}>{schemeType} Schemes</h2>
              {Object.keys(schemes[schemeType]).map((coverLevel) => {
                return (
                  <SchemeContainer
                    key={coverLevel}
                    schemes={schemes[schemeType][coverLevel]}
                    onRefreshPage={onRefreshPage}
                    baseUrl={baseUrl}
                  />
                );
              })}
            </Col>
          );
        })}
      </Row>
    </Col>
  );
};

const SchemesSummary = ({
  productName,
  productId,
  productCode,
  title,
  schemes,
  schemesInTest,
  activeSchemes,
  onRefreshPage,
  baseUrl,
  show,
}) => {
  if (!show) {
    return null;
  }
  const buttons = PRODUCT_BUTTONS[productCode];
  return (
    <div>
      <Row>
        <Col sm={12}>
          <ProductTemplateBox
            productName={productName}
            title={title}
            productIcon={ICON_MAP[productCode]}
          >
            {buttons.map((button) => {
              return (
                <Button
                  link={true}
                  className="btn-blue pad-right"
                  to={baseUrl + button.link}
                  key={button.link}
                >
                  {button.label}
                </Button>
              );
            })}
          </ProductTemplateBox>
        </Col>
        <SchemesByCoverLevel
          schemes={schemes}
          onRefreshPage={onRefreshPage}
          baseUrl={baseUrl}
        />
      </Row>

      <InternalButtonBar
        buttons={[
          {
            permissions: ['scheme.edit', 'scheme.create'],
            button: (
              <ActivateMultipleSchemesModal
                schemes={schemesInTest}
                onRefreshPage={onRefreshPage}
              />
            ),
          },
          {
            permissions: ['scheme.edit', 'scheme.create'],
            button: (
              <SchemesExportModal
                schemes={activeSchemes}
                isSchemeGroup={false}
                productId={productId}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default SchemesSummary;
